import { createAPI } from '@common'
export default {
  // 获取根文件夹
  getFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
    // 获取子文件夹
  getAdminFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefst', 'GET', config),
  // 获取移动子文件夹
  getFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60gpmefst', 'GET', config),
    // 创建子文件夹
  postAdminFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefst', 'POST', config),
      // 删除文件夹
  deleteAdminFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefst', 'DELETE', config),
    // 读文件夹
  getAdminFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60benjo0epn0gpmefs', 'GET', config),
    // 列表查询接口
  postRecommendList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0sfdpnnfoe0mjtu', 'POST', config),
    // 列表查询接口
  postRecommendWithdraw: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0sfdpnnfoe0xjuiesbx', 'GET', config),   
}
